import { render, staticRenderFns } from "./PackingListForExport.vue?vue&type=template&id=bedd1b1e"
import script from "./PackingListForExport.vue?vue&type=script&lang=js"
export * from "./PackingListForExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports